import {
    Component,
    Input,
    Output,
    ElementRef,
    EventEmitter
} from '@angular/core';

import { WindowService } from "../services/window.service";
import { Logger } from "../utils/logger";
import { filter } from "rxjs/operator/filter";

@Component({
    selector: 'filter_panel',
    templateUrl: "./filter_panel.component.html"
})
export class FilterPanel {
    @Input('show')
    public isShown = false;

    @Input()
    public productGroup;

    @Output('onHide')
    public displayEvent: EventEmitter<boolean>;

    @Output('onFilterTabChanged')
    public filterTabChanged: EventEmitter<any>;

    @Output('onFiltersChanged')
    public filtersChanged;

    public currentTab = 0;
    public currentTabName = '';

    @Input()
    public filtersNames = [];

    public filters: Array<{ type: string, list: Array<any> }> = [];

    constructor(public el: ElementRef, public windowService: WindowService, public logger: Logger) {
        this.displayEvent = new EventEmitter<boolean>();
        this.filterTabChanged = new EventEmitter<any>();
        this.filtersChanged = new EventEmitter<Array<{ type: string, list: Array<any> }>>();
    }

    hide() {
        this.displayEvent.emit(true);
    }

    onFilterTabChanged(event: any) {
        this.currentTab = event.tabId;
        this.currentTabName = event.tabName;
    }

    onAllItemsChecked(event: any) {
        let tabCheckbox = this.el.nativeElement.querySelector('#checkbox-tab-' + event.tabIndex);
        let tabContentCheckboxes = this.el.nativeElement.querySelectorAll('.checkbox-tab-content-' + event.tabIndex);

        Array.prototype.forEach.call(tabContentCheckboxes, function (tabContentCheckbox) {
            tabContentCheckbox.checked = tabCheckbox.checked !== true;

            setTimeout(() => { tabContentCheckbox.click() }, 10);
        });

        /*
            tabContentCheckboxes.forEach((tabContentCheckbox) => {
                tabContentCheckbox.checked = tabCheckbox.checked !== true;

                setTimeout(() => { tabContentCheckbox.click() }, 10);
            });
        */
    }

    resetFilters() {
        let tabCheckboxes = this.el.nativeElement.querySelectorAll('.checkbox-tab');
        let tabContentCheckboxes = this.el.nativeElement.querySelectorAll('.checkbox-tab-content');

        Array.prototype.forEach.call(tabContentCheckboxes, function (tabContentCheckbox) {
            if (tabContentCheckbox.checked) {
                setTimeout(() => {
                    tabContentCheckbox.click()
                }, 10);
            }
        });
    }

    onFiltersChanged(filterEvent: { type: string, value: any, checked: boolean }) {
        let group = null;

        let res = this.filters.filter((g) => {
            if (g.type.toLowerCase() === filterEvent.type.toLowerCase()) {
                return true;
            }
        });
        if (res && res.length > 0) {
            group = res.shift();
        } else {
            group = { type: filterEvent.type, list: [] };
            this.filters.push(group);
        }
        if (filterEvent.checked) {
            if (group.list.indexOf(filterEvent.value) == -1) {
                group.list.push(filterEvent.value);
            }
        } else {
            group.list.splice(group.list.indexOf(filterEvent.value), 1);
            if (group.list.length === 0) {
                this.filters.splice(this.filters.indexOf(group), 1);
            }
        }
        //debugger;

        this.filtersChanged.emit(this.filters);
    }
}



// WEBPACK FOOTER //
// ./src/app/filter_panel/filter_panel.component.ts